import {
    GET_ARTICULOS,
    SET_ARTICULOS,
    SET_FILTRAR_ARTICULOS,
    NO_FILTRAR_ARTICULOS,
    SET_CAD_BUSQUEDA,
    SET_CATEGORIAS,
    SET_RESULTS_PAGE
} from "../types";

const initialState = {
    cadenaBusqueda: "",
    categorias: null,
    articulos: null,
    filtroArticulos: [],
    listResultsPage: [],
    loadingBusqueda: null,
    error: null
}
// eslint-disable-next-line import/no-anonymous-default-export
export default function (state = initialState, action) {
    switch (action.type) {
        case GET_ARTICULOS:
            return {
                ...state,
                loadingBusqueda: true
            };
        case SET_ARTICULOS:
            return {
                ...state,
                articulos: action.payload,
            };
        case SET_CATEGORIAS:
            return {
                ...state,
                categorias: action.payload,
            };
        case SET_FILTRAR_ARTICULOS:
            return {
                ...state,
                loadingBusqueda: false,
                filtroArticulos: action.payload
            };
        case SET_RESULTS_PAGE:
            return {
                ...state,
                loadingBusqueda: false,
                listResultsPage: action.payload
            };
        case SET_CAD_BUSQUEDA:
            return {
                ...state,
                //loadingBusqueda: false,
                cadenaBusqueda: action.payload
            };
        case NO_FILTRAR_ARTICULOS:
            return {
                ...state,
                loadingBusqueda: false,
                filtroArticulos: action.payload 
            };

        default:
            return state
    }
}